import { announcementServiceApi } from "../../app/announcementServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  AddCommentBodyType,
  CreateSupportBodyType,
  GetCommentResponseType,
  GetQueryArgsType,
  GetSupportDetailsResponseType,
  GetSupportParamsType,
  GetSupportResponseType,
} from "../../types";

export const announcementApi = announcementServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getSupportList: builder.query<
      GetSupportResponseType,
      GetQueryArgsType<GetSupportParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getSupportList,
        ...queryArgs,
      }),
      providesTags: ["GetSupportList"],
    }),
    getMySupportList: builder.query<
      GetSupportResponseType,
      GetQueryArgsType<GetSupportParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMySupportList,
        ...queryArgs,
      }),
      providesTags: ["GetSupportList"],
    }),
    createSupport: builder.mutation<unknown, CreateSupportBodyType>({
      query: (body) => ({
        url: API_URL.createSupport,
        method: "POST",
        body,
      }),
      invalidatesTags: ["GetSupportList"],
    }),
    getSupportDetails: builder.query<GetSupportDetailsResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getSupportDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetSupportDetails", id }],
    }),
    supportClose: builder.mutation<void, string>({
      query: (id) => ({
        url: `${API_URL.supportClose}/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (result, _, id) => {
        if (result)
          return [
            "GetSupportList",
            {
              type: "GetSupportDetails",
              id,
            },
          ];

        return [];
      },
    }),
    supportFeedback: builder.mutation<
      unknown,
      { id: string; is_satisfied: number }
    >({
      query: ({ id, is_satisfied }) => ({
        url: `${API_URL.supportFeedback}/${id}`,
        method: "PATCH",
        body: { is_satisfied },
      }),
      invalidatesTags: (_, __, { id }) => [
        "GetSupportList",
        { type: "GetSupportDetails", id },
      ],
    }),
    getComment: builder.query<GetCommentResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getComment}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetComments", id }],
    }),
    addComment: builder.mutation<void, AddCommentBodyType>({
      query: (body) => ({
        url: API_URL.addComment,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, _, { support_id }) => {
        if (result)
          return [
            {
              type: "GetComments",
              id: support_id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetSupportListQuery,
  useGetMySupportListQuery,
  useCreateSupportMutation,
  useGetSupportDetailsQuery,
  useSupportCloseMutation,
  useSupportFeedbackMutation,
  useGetCommentQuery,
  useAddCommentMutation,
} = announcementApi;
